import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
//import PersonalCareImg from '../assets/images/service-page/personal-care.png' 

function PersonalCare({data}) {

  return (
    <> 
    <section className="memory-care">
      <Container>
        <Row className="align-items-center">  
          <Col sm="12" md="6" className='mb-4 mb-md-0'>
            <img className="memory-care-img" src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${data?.image}`} alt={data?.title} />
          </Col>            
          <Col sm="12" md="6" >    
            <div className="memory-care-box margin-l">        
              <div dangerouslySetInnerHTML={{ __html: data?.title }}></div>
              <div dangerouslySetInnerHTML={{ __html: data?.description }}></div>  
            </div>
          </Col>
         
        </Row>        
      </Container>
    </section>
    </>
  )
}
export default PersonalCare